// NOTE: Maybe we can merge this with SidebarPageTreeItem.tsx, and
// use a prop to determine whether it's for `home` or not

import Tooltip from '@/sharedComponents/TextEditor/components/Tooltip';
import { DotsThree, House } from '@phosphor-icons/react';
import classNames from 'classnames';
import { useState } from 'react';
import { MenuNav } from '../Nav';
import { PagesDnDWrapper } from './DnDWrapper';
import { DROP, PagesTreeItemHomeProps } from './types';

/**
 * Specific implementation of `SidebarPageTreeItem` for the home page.
 */
export function PagesTreeItemHome({
  route,
  pages,
  path,
  pageID,
  space,
  onOpenOptions,
  openPage,
}: PagesTreeItemHomeProps) {
  const [open, setopen] = useState(false);
  const [dropDirection, setdropDirection] = useState(null);
  const [isOverCurrent, setisOverCurrent] = useState(null);

  return (
    <PagesDnDWrapper
      path={path}
      space={space}
      setdropDirection={setdropDirection}
      setisOverCurrent={setisOverCurrent}
      key={pageID}
      open={open}
      setopen={setopen}
      pageTreeRole="root-page"
    >
      <div className="relative bg-transparent" data-testid="HomePage_SidebarItem_container">
        {isOverCurrent && dropDirection === DROP.TOP && (
          <div
            className={classNames('absolute left-0 w-full h-0.5 bg-primary-400', {
              'top-[-1px]': dropDirection === DROP.TOP,
            })}
          />
        )}

        <MenuNav
          pre={<House size={16} weight="bold" />}
          post={
            <Tooltip center="Page Options">
              <span
                data-testid="HomePage_SidebarItem_openOptions_button"
                className="flex items-center justify-center bg-transparent p-0.5 rounded-full transition-all ease-out duration-200 hover:bg-neutral-300 cursor-pointer"
                role="none"
                onClick={() => onOpenOptions(route?.page_id)}
              >
                <DotsThree size={16} weight="bold" />
              </span>
            </Tooltip>
          }
          selected={pageID === route?.page_id}
          onClick={() =>
            openPage(
              pages[route?.page_id].metadata?.page_type === 'link_in_bio'
                ? `/link/s/${space?.id}/${route?.page_id}`
                : `/s/${space?.slug}/${space?.id}/${route?.page_id}`
            )
          }
        >
          {pages[route?.page_id]?.name}
        </MenuNav>
      </div>
    </PagesDnDWrapper>
  );
}
